<template>
  <div class="rowSectionItem">
    <AccessoriesModal
      :is-show="isShowAccessories"
      :value="section.accessories"
      :separate="separate"
      :count="section.count"
      @close="isShowAccessories = false"
      @input="section.accessories = $event"
    />

    <div class="rowSectionItem-head">
      <div class="rowSectionItem-number">
        {{ number }}
      </div>
      <div v-if="!isEdit" class="rowSectionItem-actions">
        <a
          href="#"
          class="rowSectionItem-edit"
          title="Редактировать"
          @click.prevent="edit"
        />
        <a
          href="#"
          class="rowSectionItem-settings"
          title="Аксессуары"
          @click.prevent="showAccessories"
        />
        <a
          href="#"
          class="rowSectionItem-copy"
          title="Копировать стеллаж"
          @click.prevent="$emit('copy')"
        />
        <a
          v-if="!isPrimary"
          class="rowSectionItem-remove"
          href="#"
          title="Удалить"
          @click.prevent="$emit('remove')"
        />
      </div>
    </div>
    <RowSectionForm
      v-if="isEdit"
      class="rowSectionItem-form"
      :data="editData"
      @submit="update"
    />
    <div
      v-else
      class="rowSectionItem-body"
    >
      <div
        class="rowSectionItem-svgHolder"
        :style="{height: svgHeight + 'px'}"
      />
      <ul class="rowSectionItem-params">
        <li :class="{'rowSectionItem-additional': !isPrimary}">
          Высота: {{ height }}
        </li>
        <li :class="{'rowSectionItem-additional': !isPrimary}">
          Глубина: {{ depth }}
        </li>
        <li>Длина: {{ section.width }}</li>
        <li>Полок: {{ section.count }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import logic from '../logic';
	import AccessoriesModal from './AccessoriesModal.vue';
	import RowSectionForm from './RowSectionForm.vue';

	export default {
    provide() {
      return {
        getSectionAvailable: () => this.sectionAvailable,
      };
    },
		components: {
      AccessoriesModal,
			RowSectionForm,
		},
		props: {
			svgHeight: Number,
			number: Number,
      separate: Boolean,
			height: Number,
			depth: Number,
			section: Object,
		},
		data() {
			return {
				// isEdit: true,
        isShowAccessories: false,
			};
		},
		computed: {
      sectionAvailable() {
        return logic.getSectionAvailable(this.section);
      },
      isEdit: {
        get() {
          return this.section.isEdit;
        },
        set(value) {
          this.section.isEdit = value;
        },
      },
			isPrimary() {
				return (this.number === 0);
			},
			editData() {
				return {
					height: this.height,
					depth: this.depth,
					width: this.section.width,
					count: this.section.count,
				};
			},
		},
		methods: {
      showAccessories() {
        this.isShowAccessories = true;
      },
			edit() {
				this.isEdit = true;
			},
			update(data) {
				this.$emit('update', data);
				this.isEdit = false;
			},
		},
	}
</script>

<style scoped>
	.rowSectionItem {
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
		padding: 0 16px;
		border-right: 1px solid #DDDDDD;
	}
	.rowSectionItem-head {
		margin-bottom: 24px;
		display: flex;
		align-items: center;
	}
	.rowSectionItem-form {
		flex-grow: 1;
		overflow: hidden;
		position: relative;
		margin: 0 -16px;
		padding: 0 16px;
		z-index: 1;
		background: white;
	}
	.rowSectionItem-body {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}
  .rowSectionItem-actions {
    display: flex;
    margin-left: auto;
  }
	.rowSectionItem-number {
		margin-right: 8px;
		width: 34px;
		height: 34px;
		line-height: 34px;
		text-align: center;
		font-family: Oswald, Roboto, sans-serif;
		font-weight: 500;
		font-size: 18px;
		text-transform: uppercase;
		color: #0A53B3;
		background: #F6F6F6;
	}
	.rowSectionItem-title {
		font-family: Oswald, Roboto, sans-serif;
		font-weight: 500;
		font-size: 14px;
		text-transform: uppercase;
		color: #A7A7A7;
	}
	.rowSectionItem-params {
		margin: 16px 0 12px;
		padding: 0;
		list-style: none;
		font-size: 14px;
	}
	.rowSectionItem-params > li {
		margin-bottom: 8px;
	}
	.rowSectionItem-additional {
		color: #A7A7A7;
	}
	.rowSectionItem-remove {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/cross.svg) no-repeat center center;
	}
  .rowSectionItem-settings {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/settings.svg) no-repeat center center;
	}
	.rowSectionItem-edit {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/edit.svg) no-repeat center center;
	}
	.rowSectionItem-copy {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/copy.svg) no-repeat center center;
	}
</style>
